var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSupportTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 11.143A38.857 38.857 0 1 0 88.857 50 38.9 38.9 0 0 0 50 11.143ZM28.013 50A21.987 21.987 0 1 1 50 71.987 22.011 22.011 0 0 1 28.013 50Zm44.4 11.024a24.92 24.92 0 0 0 0-22.048l9.752-4.8a35.766 35.766 0 0 1 0 31.64Zm-4.858-42.272-5.322 9.473a24.9 24.9 0 0 0-24.466 0l-5.322-9.473a35.737 35.737 0 0 1 35.11 0ZM17.832 34.18l9.752 4.8a24.92 24.92 0 0 0 0 22.048l-9.752 4.8a35.766 35.766 0 0 1 0-31.64Zm14.613 47.068 5.322-9.473a24.9 24.9 0 0 0 24.466 0l5.322 9.473a35.737 35.737 0 0 1-35.11 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.264 45.559a1.5 1.5 0 0 0-2.094-.34l-7.67 5.528V36.739a1.5 1.5 0 0 0-3 0v16.938a1.5 1.5 0 0 0 2.377 1.217l10.047-7.242a1.5 1.5 0 0 0 .34-2.093Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportTime);
export default __webpack_public_path__ + "static/media/support-time.e3b442749285495556112e5f83794bb6.svg";
export { ForwardRef as ReactComponent };